
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Destinationweddingresortnearchandrapur() {



  const cardData =
  {
    keyword: ' Destination Wedding Resort Near Chandrapur',
    heading:  'Woodland Escape: Destination Wedding Resort Near Chandrapur ',
    headingDescription: 'Woodland Escape Resort is a stunning destination wedding resort near Chandrapur, offering nature-infused elegance for couples looking to celebrate their big day surrounded by lush greenery and serene forest vistas. With expansive lawns perfect for floral-draped ceremonies, shady tree-lined pathways for pre-wedding photo shoots, and cozy cottage accommodations for guests, this resort provides an idyllic combination of rustic charm and comfortable luxury. The in-house catering and warm hospitality ensure seamless event management, while the tranquil ambiance allows newlyweds and their loved ones to unwind and celebrate without the bustle of city venues. Every wedding hosted here becomes a memorable experience of joy, nature and togetherness.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Destination Wedding Resort Near Chandrapur",
      "description": "Plan a dream destination wedding near Chandrapur at luxurious resorts offering beautiful landscapes, elegant venues, and complete wedding services. Perfect for couples looking for a picturesque and memorable celebration."
    },
    {
      "name": "Chandrapur Wedding Venue Resort",
      "description": "Choose from top wedding venue resorts in Chandrapur featuring banquet halls, garden areas, and riverside settings. These resorts provide comprehensive facilities to host weddings of all sizes with style and comfort."
    },
    {
      "name": "Chandrapur Luxury Wedding Resort",
      "description": "Celebrate your special day at a luxury wedding resort in Chandrapur offering premium accommodations, world-class décor, and customized wedding services for a lavish and unforgettable experience."
    },
    {
      "name": "Affordable Wedding Resort Chandrapur",
      "description": "Discover budget-friendly wedding resorts in Chandrapur that combine elegance, scenic locations, and quality services without exceeding your budget. Ideal for couples seeking an affordable yet memorable wedding."
    },
    {
      "name": "Chandrapur Pre Wedding Shoot Resort",
      "description": "Capture beautiful pre-wedding moments at Chandrapur resorts offering scenic backdrops, riversides, gardens, and professional photography-friendly locations for an enchanting photo shoot."
    },
    {
      "name": "Chandrapur Outdoor Wedding Resort",
      "description": "Host an outdoor wedding at Chandrapur resorts with lush lawns, floral decorations, and open-air ceremonies. Perfect for couples who want a wedding surrounded by nature and fresh air."
    },
    {
      "name": "Chandrapur Riverside Wedding Resort",
      "description": "Celebrate by the river at Chandrapur’s riverside wedding resorts with tranquil water views, elegant décor, and serene surroundings that make your wedding day extra special."
    },
    {
      "name": "Chandrapur Hill Wedding Resort",
      "description": "Enjoy a hilltop wedding at Chandrapur resorts offering panoramic views, cool breezes, and exclusive settings. Perfect for couples seeking a serene and breathtaking wedding location."
    },
    {
      "name": "Chandrapur Family Wedding Resort",
      "description": "Plan a family-friendly wedding at Chandrapur resorts with facilities for guests of all ages, including spacious banquet areas, kid-friendly activities, and comfortable accommodations."
    },
    {
      "name": "Chandrapur Resort Wedding Packages",
      "description": "Choose from curated wedding packages at Chandrapur resorts including venue booking, catering, décor, and accommodation for a hassle-free and perfectly organized wedding."
    },
    {
      "name": "Chandrapur Wedding Booking Online",
      "description": "Easily book your wedding resort in Chandrapur online to secure your preferred date, venue, and services, ensuring a smooth planning experience for your big day."
    },
    {
      "name": "Chandrapur Resort for Marriage",
      "description": "Host your marriage at a Chandrapur resort offering elegant venues, professional staff, and complete wedding facilities. Perfect for a stress-free and memorable wedding celebration."
    },
    {
      "name": "Chandrapur Wedding Hall Resort",
      "description": "Reserve a wedding hall at Chandrapur resorts featuring spacious interiors, modern amenities, and beautiful décor options suitable for weddings, receptions, and other ceremonies."
    },
    {
      "name": "Chandrapur Marriage Destination Resort",
      "description": "Celebrate your marriage at a dedicated destination resort in Chandrapur with scenic views, luxurious accommodations, and complete wedding services for an unforgettable experience."
    },
    {
      "name": "Chandrapur Wedding Destination Packages",
      "description": "Explore comprehensive wedding destination packages in Chandrapur that include venue, catering, décor, photography, and accommodation for a seamless and memorable wedding celebration."
    }
  ],
  "tableData": [
    ["- Destination Wedding Resort Near Chandrapur", "- Chandrapur Wedding Venue Resort"],
    ["- Chandrapur Luxury Wedding Resort", "- Affordable Wedding Resort Chandrapur"],
    ["- Chandrapur Pre Wedding Shoot Resort", "- Chandrapur Outdoor Wedding Resort"],
    ["- Chandrapur Riverside Wedding Resort", "- Chandrapur Hill Wedding Resort"],
    ["- Chandrapur Family Wedding Resort", "- Chandrapur Resort Wedding Packages"],
    ["- Chandrapur Wedding Booking Online", "- Chandrapur Resort for Marriage"],
    ["- Chandrapur Wedding Hall Resort", "- Chandrapur Marriage Destination Resort"],
    ["- Chandrapur Wedding Destination Packages", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Destination Wedding Resort Near Chandrapur",
    "WhyChoosedescription": "Woodland Escape Resort is an enchanting destination wedding venue near Chandrapur. With its natural beauty, lush surroundings, and elegant open spaces, it provides the perfect romantic setting for your dream wedding."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Wedding Venues",
    "WhyChoosedescription": "Exchange vows in the midst of nature with beautifully maintained lawns and forested backdrops. The resort’s serene environment enhances every wedding ceremony with charm and grace."
  },
  {
    "WhyChooseheading": "Spacious Banquet and Celebration Areas",
    "WhyChoosedescription": "Woodland Escape Resort offers expansive lawns and versatile event spaces ideal for wedding ceremonies, receptions, and pre-wedding functions — suitable for both intimate and grand celebrations."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation for Guests",
    "WhyChoosedescription": "The resort features cozy and well-appointed rooms to accommodate your guests comfortably. Each stay combines modern amenities with a warm, nature-inspired ambiance."
  },
  {
    "WhyChooseheading": "Personalized Wedding Planning Support",
    "WhyChoosedescription": "From decor and catering to entertainment and coordination, the resort’s dedicated team helps you plan every detail, ensuring your special day is seamless and unforgettable."
  },
  {
    "WhyChooseheading": "Delicious Wedding Cuisine",
    "WhyChoosedescription": "Treat your guests to a delightful culinary experience with a wide range of freshly prepared local and multi-cuisine dishes, customized to suit your wedding theme and preferences."
  },
  {
    "WhyChooseheading": "Easily Accessible from Chandrapur",
    "WhyChoosedescription": "Located just a short drive from Chandrapur, Woodland Escape Resort offers the perfect balance of convenience and tranquility, making it an ideal destination for couples seeking a scenic and memorable wedding venue."
  }
]



















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a destination wedding resort near Chandrapur?",
    answer: "Woodland Escape Resort is one of the most beautiful destination wedding resorts near Chandrapur, offering lush green lawns, elegant décor, and a serene natural setting. It’s perfect for couples dreaming of a peaceful, nature-inspired wedding celebration."
  },
  {
    question: "How far is Woodland Escape Resort from Chandrapur city?",
    answer: "The resort is conveniently located within driving distance from Chandrapur, making it easy for guests to attend your wedding without long travel. Its scenic environment provides the ideal backdrop for memorable wedding photos."
  },
  {
    question: "What facilities does Woodland Escape Resort provide for destination weddings?",
    answer: "The resort offers spacious banquet lawns, stage setups, customized décor, catering services, guest accommodations, and ample parking. Every wedding detail can be tailored to suit your vision and traditions."
  },
  {
    question: "Can Woodland Escape Resort host pre-wedding and post-wedding events?",
    answer: "Yes! The resort is perfect for all wedding-related functions including engagement, mehendi, haldi, sangeet, and reception. The open spaces and greenery make each celebration elegant and unforgettable."
  },
  {
    question: "Does the resort provide catering and decoration services for weddings?",
    answer: "Absolutely. Woodland Escape Resort offers complete catering and décor solutions. From delicious multi-cuisine menus to beautiful floral setups, everything is managed professionally to make your big day perfect."
  },
  {
    question: "How can we book Woodland Escape Resort as a destination wedding venue near Chandrapur?",
    answer: "You can book by calling or sending a WhatsApp message to our reservations team, or by visiting our official website. Advance booking is recommended to secure your desired dates and arrangements."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patil, Chandrapur",
    text: "Our wedding at Woodland Escape Resort was truly magical! The natural setting, professional arrangements, and beautiful décor made it an unforgettable celebration. Best destination wedding resort near Chandrapur!"
  },
  {
    name: "Mr. Rahul & Family, Chandrapur",
    text: "We attended a wedding at Woodland Escape Resort and were amazed by the beauty of the venue. The food, service, and atmosphere were excellent. Highly recommended for destination weddings near Chandrapur!"
  }
];






















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Resort Near Chandrapur",
  "image": "https://woodlandescape.com/assets/images/wedding-resort-chandrapur.jpg",
  "description": "Celebrate your dream wedding at Woodlandescape Resort, the perfect destination wedding resort near Chandrapur. Enjoy luxury venues, riverside and hill settings, outdoor wedding arrangements, and family-friendly accommodations.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "128"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "49999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/destination-wedding-resort-chandrapur"
  }
};





  return (
    <div>
<Helmet>
  <title>Destination Wedding Resort Near Chandrapur | Luxury & Scenic Venues | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your dream wedding at Woodlandescape Resort, a top destination wedding resort near Chandrapur. Enjoy luxury venues, riverside and hill settings, outdoor arrangements, and family-friendly accommodations." 
  />
  <meta 
    name="keywords" 
    content="Destination Wedding Resort Near Chandrapur, Chandrapur Wedding Venue Resort, Chandrapur Luxury Wedding Resort, Affordable Wedding Resort Chandrapur, Chandrapur Pre Wedding Shoot Resort, Chandrapur Outdoor Wedding Resort, Chandrapur Riverside Wedding Resort, Chandrapur Hill Wedding Resort, Chandrapur Family Wedding Resort, Chandrapur Resort Wedding Packages, Chandrapur Wedding Booking Online, Chandrapur Resort for Marriage, Chandrapur Wedding Hall Resort, Chandrapur Marriage Destination Resort, Chandrapur Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/27.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Destinationweddingresortnearchandrapur;